import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'app-clipped-text-cell-renderer',
  templateUrl: './clipped-text-cell-renderer.component.html',
  styleUrl: './clipped-text-cell-renderer.component.scss'
})
export class ClippedTextCellRendererComponent implements ICellRendererAngularComp {

  text: string = '';
  title: string = '';
  copied = false;
  private copyTimeout: any;

  agInit(params: ICellRendererParams & { title?: string }): void {
    this.text = params.value || '';
    this.title = params.colDef?.headerName || '';
  }

  refresh(params: ICellRendererParams): boolean {
    this.text = params.value || '';
    return true;
  }

  copyText(): void {
    if (!this.text) return;
    navigator.clipboard.writeText(this.text).then(() => {
      this.copied = true;
      clearTimeout(this.copyTimeout);
      this.copyTimeout = setTimeout(() => {
        this.copied = false;
      }, 2000);
    });
  }

}
